import { Fragment } from 'react'
import MobileNavbar from './MobileNavbar'

const CustomNavbar = props => {

  return (
    <Fragment>
      <MobileNavbar />
    </Fragment>
  )
}

export default CustomNavbar
